import React, { type FunctionComponent, useCallback } from 'react'
import { Button, SVGIcon } from 'ic-snacks'
import { useGoToEditStoreGroup } from 'legacy/sections/store-groups/utils/navigation.hooks'
import {
  EVENT_TRACKING,
  trackStoreHoursEvent,
  useTrackStoreEventMetaData,
} from 'domains/store-hours-bulk/utils/eventTracking'

const pencilIcon = <SVGIcon name="pencil" />

interface Props {
  storeGroupId: string
  onEditClicked: (storeGroupId: string) => void
}

const EVENT = EVENT_TRACKING.singleStoreEditClicked

export const StoreGroupsListTableEditButton: FunctionComponent<Props> = ({
  storeGroupId,
  onEditClicked,
}) => {
  const goToEditStoreGroup = useGoToEditStoreGroup(storeGroupId)

  // bad linting
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const editAction = onEditClicked ? () => onEditClicked(storeGroupId) : goToEditStoreGroup

  const metadata = useTrackStoreEventMetaData(EVENT)
  const editActionTrack = useCallback(() => {
    trackStoreHoursEvent(EVENT, metadata)
    editAction()
  }, [metadata, editAction])

  return (
    <Button
      icon={pencilIcon}
      snacksStyle="flat"
      style={{ paddingLeft: 0, paddingRight: 0 }}
      onClick={editActionTrack}
      elementAttributes={{ 'data-testid': 'store-group-edit-button' }}
    />
  )
}
